class AgreedSalary {
    contract_id = null;
    active = false;
    rank_id = null;
    seniority = null;
    effective_from = null;
    effective_to = null;
    full = null;
    sick = null;
    travel = null;
    training = null;
    quarantine = null;
    standby = null;
    other = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default AgreedSalary;
